import { render } from "./ExternalLink.vue?vue&type=template&id=1a655ad9&bindings={}"
import script from "./ExternalLink.vue?vue&type=script&lang=js"
export * from "./ExternalLink.vue?vue&type=script&lang=js"

import "./ExternalLink.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script